export const SET_NEWSMESSAGES = 'SET_NEWSMESSAGES';

export const setNewsMessages = (messages) => {    
    return { type: SET_NEWSMESSAGES, messages: messages};
};